import React from 'react';
import { HashLink } from 'react-router-hash-link';
import BrandLogo from './BrandLogo';

export default function Footer() {
  return (
    <footer>
      <div className="ft-grid">
        <div className="ft-brand">
          <span className="logo-frame logo-frame--footer">
            <BrandLogo placement="footer" />
          </span>
          <p className="ft-about">
            Engineering color, function, and sustainability into every polymer solution — from our laboratory to your
            production line, and your product to the world.
          </p>
        </div>
        <div className="ft-col">
          <h5>Solutions</h5>
          <HashLink smooth to="/#solutions">
            Color Masterbatch
          </HashLink>
          <HashLink smooth to="/#solutions">
            White Masterbatch
          </HashLink>
          <HashLink smooth to="/#solutions">
            UV Stabilizers
          </HashLink>
          <HashLink smooth to="/#solutions">
            NIR Absorbers
          </HashLink>
          <HashLink smooth to="/#solutions">
            Antistatic MB
          </HashLink>
          <HashLink smooth to="/#solutions">
            Bio &amp; rPET
          </HashLink>
        </div>
        <div className="ft-col">
          <h5>Company</h5>
          <HashLink smooth to="/#trends">
            Trend Intelligence
          </HashLink>
          <HashLink smooth to="/#innovation">
            Innovation Lab
          </HashLink>
          <HashLink smooth to="/#sustainability">
            Sustainability
          </HashLink>
          <HashLink smooth to="/#markets">
            Markets
          </HashLink>
          <HashLink smooth to="/#gallery">
            Gallery
          </HashLink>
          <span>Careers</span>
          <span>News &amp; Insights</span>
        </div>
        <div className="ft-col">
          <h5>Contact</h5>
          <HashLink smooth to="/contact">
            Contact form
          </HashLink>
          <span>info@auraluxmaterials.com</span>
          <span>Tech@auraluxmaterials.com</span>
          <span style={{ marginTop: 8 }}>Mumbai, India</span>
          <span>Dubai, UAE</span>
          <span>Singapore</span>
        </div>
      </div>
      <div className="ft-bot">
        <p>© 2025 Auralux Global Pvt. Ltd. All rights reserved. · auraluxmaterials.com</p>
        <div className="ft-certs">
          <span className="ft-c">ISO 9001</span>
          <span className="ft-c">ISO 14001</span>
          <span className="ft-c">FDA 21 CFR</span>
          <span className="ft-c">REACH</span>
          <span className="ft-c">RoHS</span>
          <span className="ft-c">EN 71-3</span>
        </div>
      </div>
    </footer>
  );
}
